import { config, apiPath } from "@backstagex/core/src/config";

const fields = [
  {
    type: 'bsx-label',
    label: "ID",
    model: "id",
    fieldClasses: 'bold',
  },
  {
    type: 'bsx-label',
    label: '會員姓名',
    model: 'user_name',
    fieldClasses: 'bold',
  },
  {
    type: 'bsx-label',
    label: '會員病歷號',
    model: 'user_patient_no',
    fieldClasses: 'bold',
  },
  {
    type: "bsx-label",
    label: "問題",
    model: "question",
    fieldClasses: 'bold',
  },
  {
    type: "x-imageField",
    label: "問題截圖",
    model: "question_image",
  },
  {
    type: "bsx-label",
    label: "連絡電話",
    model: "contact_number",
    fieldClasses: 'bold',
  },
  {
    type: "bsx-select",
    label: "處理狀態",
    model: "question_status",
    required: true,
    values: [
      { id: "DOING", name: "處理中" },
      { id: "TODO", name: "待處理" },
      { id: "DONE", name: "已處理" },
      { id: "IMPOROVE", name: "後續改善" },
    ],
    validator: function () {
      this.validation();
    },
  },

  {
    type: 'x-opinionResponse',
    label: '歷史回覆',    
    required: false,
    style: 'matrix',
    values() {
      var xmlHttp = new XMLHttpRequest();
      xmlHttp.open("GET", config.apiHost + '/api/backstagex/' + this.$route.params.menuItemKey + '/opinion-response-list?id='+this.$route.params.id, false);
      xmlHttp.setRequestHeader('Authorization', 'Bearer ' + localStorage.token);
      xmlHttp.send();
      return JSON.parse(xmlHttp.responseText).data.data;
    }
  },  
];

export default fields;
